"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapBanners = function mapBanners(bannersSlice) {
  if (!bannersSlice || bannersSlice.length === 0) return;
  var bannersArray = [];
  bannersSlice.map(function (banner) {
    var _banner$primary$image, _banner$primary$blurh, _banner$primary$url, _banner$primary$url2, _banner$primary$url2$;
    bannersArray.push({
      title: banner.primary.title.length > 0 ? banner.primary.title[0].text : "",
      subHeading: banner.primary.subtitle && banner.primary.subtitle.length > 0 ? banner.primary.subtitle[0].text : "",
      svgTitle: (_banner$primary$image = banner.primary.imagetitle) !== null && _banner$primary$image !== void 0 && _banner$primary$image.url ? {
        svg: banner.primary.imagetitle.url,
        width: banner.primary.imagetitle.dimensions ? banner.primary.imagetitle.dimensions.width : "75px",
        height: banner.primary.imagetitle.dimensions ? banner.primary.imagetitle.dimensions.height : "75px"
      } : undefined,
      buttonLabel: banner.primary.buttontext.length > 0 ? banner.primary.buttontext[0].text : "",
      description: banner.primary.description && banner.primary.description.length > 0 ? banner.primary.description[0].text : "",
      image: (0, _image["default"])(banner.primary.image, ((_banner$primary$blurh = banner.primary.blurhash) === null || _banner$primary$blurh === void 0 ? void 0 : _banner$primary$blurh.length) > 0 && banner.primary.blurhash[0].text),
      colorSchema: {
        fontColor: banner.primary.textcolor,
        bgColor: banner.primary.background
      },
      link: banner.primary.is_url_external ? (_banner$primary$url = banner.primary.url) === null || _banner$primary$url === void 0 ? void 0 : _banner$primary$url.url : (_banner$primary$url2 = banner.primary.url) === null || _banner$primary$url2 === void 0 ? void 0 : (_banner$primary$url2$ = _banner$primary$url2.url) === null || _banner$primary$url2$ === void 0 ? void 0 : _banner$primary$url2$.replace("https:/", ""),
      position: banner.primary.contentposition
    });
  });
  return bannersArray;
};
var _default = mapBanners;
exports["default"] = _default;